import { Table } from "react-bootstrap";
import styled from "styled-components";

interface IChargeRow {
    rowHeight?: number
}

export const ChargeRow = styled.div`
    height: ${(p: IChargeRow) => p.rowHeight ? p.rowHeight + 'px !important' : '35px !important'};

    & > div {
        padding-left: 7px;
        padding-right: 7px;
    }
`;

export const NonGlobalInsuranceRow = styled.tr`
    & > td:nth-child(1) {
        font-weight: 700;
    }
`;

export const TableWrapper = styled(Table)`
    margin-bottom: 0px;

    & > tbody > tr > td {
        vertical-align: middle;
    }

    & > tbody > tr > td.no-border {
        border-top: 0 none !important;
    }

    & > thead > tr > th.amount {
        text-align: right;
        padding-right: 20px;
    }

    & > tbody > tr > td.amount {
        text-align: right;
    }
`;